// import './less/video.less';

export default function () {
	let videoButton = document.querySelector('#js-show-main-video');
	let videoPopup = document.querySelector('#js-main-video-popup');
	if (videoPopup) {
		let iframe = videoPopup.querySelector('iframe');
	}
	if (videoButton && videoPopup && iframe) {
		videoButton.addEventListener('click', function (e) {
			e.preventDefault();
			videoPopup.style.display = 'block';
			iframe.setAttribute('src', videoButton.getAttribute('href'))
		});
		
		
		let closers = document.querySelectorAll('.js-main-video-popup-close');
		if (closers) {
			closers.forEach(function (closer) {
				closer.addEventListener('click', function (e) {
					e.preventDefault();
					videoPopup.style.display = 'none';
					iframe.setAttribute('src', '#');
				})
			})
		}
	}
}



// WEBPACK FOOTER //
// ../components/video/video.js